export default "__VITE_ASSET__DlVJgl7D__"